/* Keep M02 and M03 as independent Shopify sections. */
(() => {
  // M02 no longer receives a wrapper that also owns M03's height. Keeping this
  // file and the Shopify section events preserves the existing editor contract.
  function refresh() {
    document.querySelectorAll('[data-v31-scene-section]').forEach(scene => {
      scene.closest('.shopify-section')?.classList.add('v31-scene-section-independent');
    });
    document.querySelectorAll('.terrain-showcase').forEach(section => {
      section.closest('.shopify-section')?.classList.add('v31-terrain-section-independent');
    });
  }
  refresh();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
  document.addEventListener('shopify:section:reorder', refresh);
  document.addEventListener('shopify:block:select', event => {
    const id = event.detail?.blockId;
    const link = Array.from(document.querySelectorAll('.scene-btn')).find(el => el.dataset.blockId === id);
    link?.focus({preventScroll:true});
  });
})();
